// src/Tuning/WhyChooseUs/WhyChooseUsAdd/WhyChooseUsAdd.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Create } from 'adminApi/WhyChooseUsApi/WhyChooseUs';
import { validateForm } from 'utils/validation';
import { WhyChooseUsAddRules } from "validation/ValidationRules";
import Spinner from 'Common/Globle/Spinner';
import AddWhyChooseUsForm from './Componates/AddWhyChooseUsForm';
import fields from '../json/WhyChooseUsFields.json';
import useFormChange from 'Hooks/useFormChange';
import useFormSubmit from 'Hooks/useFormSubmit';

const WhyChooseUsAdd = () => {
  const navigate = useNavigate();
  const { formdata } = fields;
  const initialValues = formdata.reduce((acc, f) => ({ ...acc, [f.name]: '' }), {});

  const { values, errors, handleChange, handleFileChange, setErrors } = useFormChange(
    initialValues,
    WhyChooseUsAddRules
  );

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const fd = new FormData();
      Object.entries(formValues).forEach(([k, v]) => fd.append(k, v ?? ''));
      return await Create({ data: fd });
    },
    (vals) => {
      const err = validateForm(vals, WhyChooseUsAddRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    'Create entry successfully'
  );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner={true} />}
      <AddWhyChooseUsForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        imagePreview={values.iconPreview || values.icon}
        title="Create Why Choose Us"
        handleFileChange={handleFileChange}
      />
    </>
  );
};

export default WhyChooseUsAdd;
